import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { type ViewInformationModalProps } from '../../config/modalConfig';
import { useHippoText } from '../../hooks/useHippoText';

const ViewInformationModal = ({
    showModal,
    closeModal,
    modalProps
}: {
    showModal: boolean;
    closeModal: () => void;
    modalProps: ViewInformationModalProps;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    return (
        <ModalOverlay isOpen={showModal} onDismiss={closeModal}>
            <ModalDialog closeIconHandler={closeModal}>
                <div className="u-spacing-inset-l">
                    <div className="u-spacing-inset-l--stretch-max">
                        <h4 className="u-spacing-stack-sm">{modalProps.title}</h4>
                        {modalProps.description && (
                            <p className="u-spacing-stack-sm">{modalProps.description}</p>
                        )}
                        {modalProps.secondDescription && (
                            <p className="u-spacing-stack-sm">{modalProps.secondDescription}</p>
                        )}
                        {modalProps.rawHtmlDescription && (
                            <div
                                dangerouslySetInnerHTML={{ __html: modalProps.rawHtmlDescription }}
                            />
                        )}
                    </div>
                    <Button onClick={modalProps.onMainButtonClick ?? closeModal}>
                        {modalProps.mainButtonText ?? getHippoText('DSS-COMMON-CLOSE')}
                    </Button>
                    {modalProps.isShowSecondaryButton && (
                        <Button
                            theme={modalProps.secondaryButtonTheme}
                            onClick={modalProps.onSecondaryButtonClick}
                        >
                            {modalProps.secondaryButtonText}
                        </Button>
                    )}
                </div>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default ViewInformationModal;
